import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext({ lang: "tr", t: translations.tr, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("vakar_lang") || "tr";
    } catch {
      return "tr";
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem("vakar_lang", l); } catch (err) { void err; }
    document.documentElement.lang = l;
    document.title = translations[l].admin?.loginTitle ? `${translations[l].nav.home === "Anasayfa" ? "Vakar Agency — Dijital Dünyada Fark Yaratan Tek Ajans" : "Vakar Agency — The Only Agency That Makes a Difference"}` : "Vakar Agency";
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = lang === "tr" ? "Vakar Agency — Dijital Dünyada Fark Yaratan Tek Ajans" : "Vakar Agency — The Only Agency That Makes a Difference";
  }, [lang]);

  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
